import { ComponentMenuBar } from "@components";
import { PATH_MEMBERCARD, PATH_USER_SETTING, enumNavigation, enumTheme } from "@configs";
import { IInfo, IMemberShipTiers } from "@interfaces";
import { selectMerchant, setDetailUser } from "@redux";
import { RenderMeta } from "@utils";
import { Skeleton } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { formatDateFull } from "src/Utils/dateUtil";
import styled, { CSSProperties } from "styled-components";
import { IconEditProfile } from "./icon/IconEditProfile";
import { IconPoint } from "./icon/Point";
import { RightArrow } from "./icon/RightArror";

interface IProps {
    themeColor: string;
    userInfo: IInfo | null;
    memberShipTiers: IMemberShipTiers[];
    under: enumNavigation;
    handleToggleUnder: (value: enumNavigation) => void;
    handleToggleQrCode: () => void;
    handleSwitchUserSetting: () => void;
    handleSwitchTier: () => void;
}

const styleAvatarUser: CSSProperties = {
    marginTop: "-52px",
    width: "64px",
    height: "64px",
};
const styleCircleImg: CSSProperties = {
    width: "64px",
    height: "64px",
};
export const ComponentNewProfile = (props: IProps) => {
    //page hook
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { themes } = useSelector(selectMerchant);
    const themeMode = themes?.themeMode || "light";
    const merchant = useSelector(selectMerchant);
    const history = useHistory();
    //page variable
    const {
        themeColor,
        userInfo,
        memberShipTiers,
        under,
        handleToggleUnder,
        handleToggleQrCode,
        handleSwitchUserSetting,
        handleSwitchTier,
        // handleCoupon,
    } = props;

    // current membership used bath
    const currentPoint = userInfo?.totalPoints || 0;
    const currentTierPointThreshold = userInfo?.memberTier?.pointThreshold || 0;
    const [isLoading, setIsloading] = useState(false);

    // next membership
    const nextTiers = memberShipTiers?.filter(
        (item) =>
            item.pointThreshold > currentPoint &&
            item._id !== userInfo?.memberTier?._id &&
            item.pointThreshold > currentTierPointThreshold
    );
    const sortNextTiers = nextTiers.sort(
        (first, second) => first.pointThreshold - second.pointThreshold
    );
    const nextTierAmount = sortNextTiers.length > 0 ? sortNextTiers[0]?.pointThreshold : 0;
    // calculate percentage of next lvl and current
    const percentage = (+currentPoint / +nextTierAmount) * 100;
    // last active profile
    // const lastUpdatedDate = userInfo?.lastActive || "";

    const handleDetail = () => {
        dispatch(setDetailUser());
    };
    const openProfileForm = () => {
        history.push(PATH_USER_SETTING);
    };
    const modeColor = themeMode === enumTheme.DARK ? "#f1f1f1" : "#000000";

    const handleClickMemberCard = () => {
        history.push(PATH_MEMBERCARD);
    };

    const handleEdit = () => {
        history.push(PATH_USER_SETTING);
    };

    useEffect(() => {
        setIsloading(true);
        if (userInfo) {
            setIsloading(false);
        }
    });

    if (merchant?.advanceSettings?.advanceFeature?.isCorporateUi) {
        let elementToHide: HTMLElement | null = document.getElementById("bannersme");

        if (elementToHide) {
            elementToHide.style.display = "none";
        }
    }

    return (
        <>
            <RenderMeta title={t("meta.profile_page")} />
            <div className="background"></div>
            <div className="preview">
                <StyledPageProfile
                    themeColor={themes?.themeColor!}
                    colorTier={userInfo?.memberTier?.textOverlayColor}
                >
                    <Skeleton
                        avatar
                        active
                        loading={isLoading}
                        title={{ width: 90 }}
                        paragraph={{ rows: 1, width: 171 }}
                    >
                        <div className="layouts-profile">
                            <div className="layout-header-profile">
                                <div className="img-profile">
                                    {/* <img src="../images/img-profile.png" alt="imgprofile" /> */}
                                    <img
                                        src={
                                            userInfo?.avatar ||
                                            "../images/img-profile-default-01.png"
                                        }
                                        alt="imgprofile"
                                    />
                                </div>
                                <div className="fullname">
                                    {merchant?.advanceSettings?.tier?.isFullName
                                        ? userInfo?.contact?.fullName
                                        : userInfo?.contact?.firstName +
                                        " " +
                                        userInfo?.contact?.lastName}{" "}
                                    <span onClick={handleEdit}>
                                        <IconEditProfile />
                                    </span>
                                </div>
                                <div className="point">
                                    {merchant?.securityConfig?.isPointDisplay === true && (
                                        <>
                                            {userInfo?.totalPoints !== undefined ? (
                                                <StyledPointTier
                                                    color={userInfo?.memberTier?.textOverlayColor}
                                                >
                                                    {userInfo.totalPoints.toLocaleString()} {t("page.point")}
                                                </StyledPointTier>
                                            ) : null}
                                        </>
                                    )}
                                    {merchant?.advanceSettings?.tier?.isMemberShipTier ? (
                                        <StyledColorTier
                                            color={userInfo?.memberTier?.textOverlayColor}
                                        >
                                            {userInfo?.memberTier?.tierName}
                                        </StyledColorTier>
                                    ) : null}
                                    {/* Valid before : {formatDateMath(userInfo?.contact?.memberCurrentTierDate)} */}
                                    {/* <span>{userInfo?.memberTier?.tierName}</span> */}
                                </div>
                                <div className="edit" onClick={handleEdit}>
                                    <RightArrow />
                                </div>
                            </div>
                            {merchant?.advanceSettings?.tier?.isMemberShipTier ? (
                                <div
                                    className="layout-card-profile"
                                    onClick={handleClickMemberCard}
                                >
                                    <img src={userInfo?.memberTier?.benefitCardImage} alt="" />
                                    <div className="detail-card-profile">
                                        {merchant?.securityConfig?.isPointDisplay && (
                                            <>
                                                <div className="point-card-profile">
                                                    {userInfo?.totalPoints !== undefined ? userInfo?.totalPoints.toLocaleString() : "0"}
                                                    <span>
                                                        <IconPoint />
                                                    </span>
                                                </div>
                                            </>
                                        )}
                                        <div className="text-card-profile">
                                            Member Since : {formatDateFull(userInfo?.createdAt)}
                                            <span>
                                                <img src="../images/ic-arrow-right.svg" alt="" />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="reward-card-profile">Memberships</div>
                                </div>
                            ) : (
                                <div
                                    className="layout-card-profile"
                                    onClick={handleClickMemberCard}
                                >
                                    <img src={userInfo?.memberTier?.benefitCardImage} alt="" />
                                    <div className="detail-card-profile">
                                        {merchant?.securityConfig?.isPointDisplay && (
                                            <>
                                                <div className="point-card-profile">
                                                    {userInfo?.totalPoints !== undefined ? userInfo?.totalPoints.toLocaleString() : "0"}
                                                    <span>
                                                        <IconPoint />
                                                    </span>
                                                </div>
                                            </>
                                        )}
                                        <div className="text-card-profile">
                                            Member Since : {formatDateFull(userInfo?.createdAt)}
                                            <span>
                                                <img src="../images/ic-arrow-right.svg" alt="" />
                                            </span>
                                        </div>
                                    </div>
                                    {/* <div className="reward-card-profile">
                            Memberships
                        </div> */}
                                </div>
                            )}
                        </div>
                        <ComponentMenuBar />
                    </Skeleton>
                </StyledPageProfile>
            </div>
        </>
    );
};

const StyledColorTier = styled.span`
    /* color: ${(props) => props.color || "#000"}; */
    color: #000;
    font-weight: 600;
`;
const StyledPointTier = styled.span`
    /* color: ${(props) => props.color || "#000"}; */
    color: #000;
    font-weight: 600;
`;

const StyledPageProfile = styled.div<{ themeColor: string; colorTier: string | undefined }>`
    .ant-skeleton {
        background-color: rgba(0, 0, 0, 0.2);
        padding: 12px;
        border-radius: 14px;
        width: calc(100% - 0px);
        .ant-skeleton-header {
            span {
                width: 46px;
                height: 46px;
            }
        }
        .ant-skeleton-title {
            height: 10px;
            border-radius: 4px;
            margin-top: 3px;
            margin-bottom: 12px;
        }
        .ant-skeleton-paragraph {
            margin-top: 0;
            li {
                height: 10px;
                border-radius: 4px;
                margin-top: 0;
                margin-bottom: 8px;
            }
        }
    }
    .layouts-profile {
        .layout-header-profile {
            position: relative;
            padding: 10px 30px 10px 70px;
            margin-bottom: 10px;
            .img-profile {
                width: 50px;
                height: 50px;
                border-radius: 100%;
                overflow: hidden;
                border: 2px solid ${(p) => p.themeColor};
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 100%;
                    border: 1px solid #fff;
                }
            }
            .fullname {
                font-size: 18px;
                line-height: 22px;
                /* color: ${(props) => props.colorTier || "#000"}; */
                color: #000;
                font-weight: 500;
                margin-bottom: 5px;
                span {
                    margin-left: 5px;
                    margin-top: -2px;
                    filter: grayscale(1);
                }
            }
            .point {
                font-size: 12px;
                line-height: 16px;
                span {
                    &:nth-child(2) {
                        position: relative;
                        padding-left: 5px;
                        margin-left: 5px;
                        &:after {
                            content: "";
                            position: absolute;
                            left: 0;
                            top: 50%;
                            transform: translateY(-50%);
                            width: 1px;
                            height: 10px;
                            background-color: #000;
                        }
                    }
                }
            }
            .edit {
                position: absolute;
                right: 0;
                top: 50%;
                cursor: pointer;
                transform: translateY(-50%);
            }
        }

        .layout-card-profile {
            position: relative;
            min-height: 110px;
            margin-bottom: 10px;
            border-radius: 16px;
            /* max-height: 110px; */
            overflow: hidden;
            background-color: #ddd;
            img {
                width: 100%;
            }
            .detail-card-profile {
                position: absolute;
                left: 20px;
                top: 10px;
                .point-card-profile {
                    font-size: 15px;
                    font-weight: 600;
                    display: flex;
                    align-items: center;
                    color: #fff;
                    margin-bottom: 5px;
                    span {
                        margin-left: 5px;
                        img {
                            width: 16px;
                        }
                    }
                }
                .text-card-profile {
                    font-size: 11px;
                    color: #fff;
                }
            }
            .reward-card-profile {
                position: absolute;
                top: 17px;
                right: 17px;
                padding: 6px 10px;
                font-size: 10px;
                color: #fff;
                border-radius: 50px;
                background-color: #c4a363;
            }
        }
    }
`;
